import { createBrowserRouter } from "react-router-dom";
import App from "../App";
import HomeView from "../pages/HomeView";
import RigidToolDisplayNodeView from "../pages/RigidToolDisplayNodeView";
import ToolsView from "../pages/ToolsView";

const router = createBrowserRouter([
    {
        path: "/",
        element: <App />,
        children: [
            {
                path: "/",
                element: <HomeView />
            },
            {
                path: "/capabilities",
                element: <ToolsView />
            },
            {
                path: "/capabilities/tool-display",
                element: <RigidToolDisplayNodeView />
            }
        ]
    }
]);

export default router;
